/// Custom library of knockout extenders ///

ko.extenders.inputByRegex = function (target, regex) {
    //create a writable computed observable to intercept writes to our observable
    var result = ko.pureComputed({
        read: target,  //always return the original observables value
        write: function (newValue) {
            var current = target(),
                valueToWrite = newValue.replace(regex, '');

            //only write if it changed
            //if the new value is the same, but a different value was written, force a notification for the current field
            if (valueToWrite !== current) {
                target(valueToWrite);
            } else if (newValue !== current) {
                target.notifySubscribers(valueToWrite);
            }
        }
    }).extend({ notify: 'always' });

    //initialize with current value
    result(target());

    //return the new computed observable
    return result;
}

// http://stackoverflow.com/questions/13701728/how-to-create-knockout-observable-subscription-that-fires-only-once
ko.extenders.fireOnce = function (target) {
    var fired = false;
    var result = ko.computed({
        read: target,
        write: function (newValue) {
            var current = target();
            if (newValue !== current && !fired) {
                fired = true;
                target(newValue);
            }
        }
    });
    result(target());
    return result;
};

ko.extenders.isDirty = function (target, isDirtyFlag) {
    var result = ko.computed({
        read: target,
        write: function (newValue) {
            var current = target();
            if (newValue !== current) {
                target(newValue);
                if (isDirtyFlag) {
                    isDirtyFlag(true);
                } else {
                    console.error('isDirty extender does not have isDirtyFlag.');
                }
            }
        }
    });
    result(target());
    return result;
};

ko.extenders.formBehavior = function (target, options) {
    //add some sub-observables to our observable
    target.hasError = ko.observable();
    target.error = ko.observable();
    target.unformatted = ko.observable();

    if (!options.displayName) {
        console.error('displayName is not provided. Cannot generate error messages.');
    }
    
    // required fields: 
    //      displayName: used to generate error messages
    //
    // optional validation fields:
    //      required: value must be present and cannot be whitespace
    //      length options: exactLength, minLength, maxLength (exactLength trumps min/max)
    //      regex options: regex, regexMessage. regexMessage is not required, but defaults to 'DisplayName has an invalid format'
    //      numericLength: the length of the digits (ignores non-numerics)
    //
    // optional formatting fields:
    //      format: currency, phone
    //      defaultValue: force it to take a default such as 0.00 for currency
    //      disallowedInput: user can only type these values

    // formatting
    function formatThenValidate(newValue) {

        var formatted = newValue;
        var unformatted = newValue;

        // Treat nulls like empty strings
        if (newValue === null || typeof newValue === "undefined") {
            newValue = '';
        } else if (options.disallowedInput) {
            newValue = newValue.replace(options.disallowedInput, '');
        }

        switch (options.format) {
            case 'currency':
                var defaultValue = options.default || null;

                var number = parseFloat(newValue.replace(/[^0-9\.]/g, ''));
                if (isNaN(number)) {
                    formatted = defaultValue;
                    unformatted = defaultValue;
                } else {
                    unformatted = number.toFixed(2);
                    formatted = unformatted.replace(/(\d)(?=(\d{3})+\.)/g, '$1,'); // Add commas
                }

                break;
            case 'phone':

                unformatted = newValue.replace(/[^0-9]/g, '');
                if (unformatted.length === 0) {
                    formatted = '';
                } else if (unformatted.length < 4) {
                    formatted = unformatted.replace(/(\d{1,3})/, '($1');
                } else if (unformatted.length < 7) {
                    formatted = unformatted.replace(/(\d{3})(\d{1,3})/, '($1) $2');
                } else {
                    formatted = unformatted.substring(0, 10).replace(/(\d{3})(\d{3})(\d{0,4})/, '($1) $2-$3');
                }

                break;
        }

        // Now set any validation messages. Use the formatted value.
        var errorMessage = '';
        var characterType = options.numeric ? ' digits' : ' characters';

        newValue = formatted;

        if (options.required && (!newValue || !newValue.replace(/\s/g, ''))) {
            errorMessage = options.displayName + ' is required.';
        } else if (newValue && newValue.length > 0) {
            if (options.exactLength && options.exactLength !== newValue.length) {
                errorMessage = options.displayName + ' must be ' + options.exactLength + characterType + ' long.';
            } else if (options.minLength && options.minLength > newValue.length) {
                errorMessage = options.displayName + ' must be at least ' + options.minLength + characterType + ' long.';
            } else if (options.maxLength && options.maxLength < newValue.length) {
                errorMessage = options.displayName + ' cannot be more than ' + options.maxLength + characterType + ' long.';
            } else if (options.regex && !RegExp(options.regex).test(newValue)) {
                errorMessage = options.regexMessage || options.displayName + ' has an invalid format.';
            } else if (options.numericLength && options.numericLength !== newValue.replace(/[^0-9]/g, '').length) {
                errorMessage = options.displayName + ' must be ' + options.numericLength + ' digits long.';
            }
        }

        // If we are using a grouped error message container, push it.
        if (options.errorMessages) {

            var item;
            ko.utils.arrayForEach(options.errorMessages(), function (v) {
                if (v.name() === options.displayName) {
                    item = v;
                }
            });

            // If we need to add the error message and there is already an item, update it.
            // If we have an error message but no item, add it.
            // If we have no new error but we have an old item, remove it.
            if (errorMessage && item) {
                item.error(errorMessage);
            } else if (errorMessage) {
                options.errorMessages.push(new alkamiviewmodels.ErrorMessage({ name: options.displayName, error: errorMessage }));
            } else if (item) {
                options.errorMessages.remove(item);
            }
        }

        target.hasError(errorMessage !== '');
        target.error(errorMessage);
        target.unformatted(unformatted); // The clean, unformatted value is a sub-observable

        if (target() !== formatted) {
            target(formatted); // The observable shows the formatted result to the user
        }
        
    }

    // format and validate it.
    if (options.runOnInit) {
        formatThenValidate(target());
    }

    //validate whenever the value changes
    target.subscribe(formatThenValidate);

    //return the original observable
    return target;
};

ko.extenders.isRequired = function (target, options) {
    var overrideMessage = '';
    var summaryMessage = '';

    if (typeof(options) === 'string') {
        overrideMessage = options;
        summaryMessage = overrideMessage;
    } else {
        overrideMessage = options.overrideMessage;
        summaryMessage = options.summaryMessage;
    }

    target.hasError = ko.observable();
    target.hasServerError = ko.observable();
    target.validationMessage = ko.observable();
    target.validationSummary = ko.observable();
    target.isEmpty = ko.observable();
    target.requiredMessage = ko.observable();

    function validate(newValue) {
        target.isEmpty(newValue ? false : true);
        target.requiredMessage(newValue ? "" : overrideMessage || "This field is required");
        if (target.isEmpty()) {
            target.hasServerError(false);
            target.validationMessage(target.requiredMessage());
            target.validationSummary(summaryMessage);
        }
    }
    validate(target());
    target.subscribe(validate);

    return target;
};

ko.extenders.areEqual = function (target, options) {
    target.hasError = ko.observable();
    target.validationMessage = ko.observable();

    function validate(newValue) {
        if (options.ignoreCase && options.otherVal() != null && newValue != null)
            target.hasError(options.otherVal().toUpperCase() !== newValue.toUpperCase());
        else
            target.hasError(options.otherVal() !== newValue);

        target.validationMessage(!options.message ? '' : options.message || "Values are not the same");
    }
    validate(target());
    target.subscribe(validate);

    function otherChanged(other) {
        if (options.ignoreCase && other != null && target() != null)
            target.hasError(other.toUpperCase() !== target().toUpperCase());
        else
            target.hasError(other !== target());

        target.validationMessage(!options.message ? '' : options.message || "Values are not the same");
    }
    options.otherVal.subscribe(otherChanged);

    return target;
};

ko.extenders.regexMatch = function (target, options) {
    target.hasError = ko.observable();
    target.isregexmatch = ko.observable();
    target.validationMessage = ko.observable();

    function validate(newValue) {
        var re = new RegExp(options.regex());
        target.hasError(!re.test(newValue));
        target.isregexmatch(!re.test(newValue));
        target.validationMessage(!options.message ? '' : options.message || "Does not match pattern");
    }
    validate(target());
    target.subscribe(validate);

    return target;
};

ko.subscribable.fn.trimmed = function () {
    return ko.computed({
        read: function () {
            return $.trim(this());
        },
        write: function (value) {
            this($.trim(value));
            this.valueHasMutated();
        },
        owner: this
    }).extend({ notify: 'always' });
};

ko.extenders.minimumValue = function (target, options) {
    target.hasError = ko.observable();
    target.validationMessage = ko.observable();
    target.validationSummary = ko.observable();

    function validate(newValue) {
        var hasError = false;
        var errorMessage = '';
        if (options.minValue())
        {
            var val = parseFloat(newValue.replace(/[^0-9.]/g, ''));
            if (val < options.minValue()) {
                errorMessage = options.minimumMessage() || "This field does not meet the minimum value of " + options.minValue();
                hasError = true;
            }
        }
        target.hasError(hasError);
        target.validationMessage(errorMessage);
        target.validationSummary(options.summaryMessage);
    }
    validate(target());
    target.subscribe(validate);

    return target;
}